import { createRouter, createWebHistory } from "vue-router";
import Login from "../views/Login.vue";
// import Login from "../views/LoginOtp.vue";
import StudentPasswordChange from "@/views/Student/PasswordChange.vue";
import StudentUserProfile from "@/views/Student/UserProfile.vue";
import StudentCurriculum from "@/views/Student/Curriculum.vue";
import StudentCommunity from "@/views/Student/Community.vue";
import StudentMyCourse from "@/views/Student/MyCourse.vue";
import StudentHome from "@/views/Student/StudentHome.vue";
import InstructorHome from "@/views/Instructor/InstructorHome.vue";
import InstructorDashboard from "@/views/Instructor/Dashboard.vue";
import InstructorCourses from "@/views/Instructor/InstructorCourses.vue";
import InstructorMessages from "@/views/Instructor/Dashboard/Messages.vue";
import InstructorStudents from "@/views/Instructor/Dashboard/Students.vue";
import InstructorAssignments from "@/views/Instructor/Dashboard/Assignments.vue";
import InstructorForums from "@/views/Instructor/Dashboard/Forums.vue";
import SignUp from "@/views/SignUp.vue";
import InstructorQuizs from "@/views/Instructor/Dashboard/Quizs.vue";
import InstructorClasses from "@/views/Instructor/Dashboard/LiveClasses.vue";
import InstructorNewCourses from "@/views/Instructor/NewCourse.vue";
import InstructorCourseAdd from "@/views/Instructor/AddLessionUnit.vue";
import EditorTry from "@/views/Instructor/EditorTry.vue";
import HomeHelpIn from "@/views/Instructor/HomeHelpIn.vue";
import InstructorAssignmentsSubmitted from "@/views/Instructor/Dashboard/AssignementsSubmitted.vue";
import InstructorCourseEdit from "@/views/Instructor/EditCourse.vue";
import StudentCourse from "@/views/Student/CoursePreview.vue";
import StudentDashboard from "@/views/Student/Dashboard.vue";
import StudentCourseProgress from "@/views/Student/Dashboard/CourseProgress.vue";
import StudentMessages from "@/views/Student/Dashboard/Messages.vue";
import StudentAssignments from "@/views/Student/Dashboard/Assignments.vue";
import StudentVideoPreview from "@/views/Student/Dashboard/CourseVideo.vue";
import StudentForums from "@/views/Student/Dashboard/Forums.vue";
import StudentClasses from "@/views/Student/Dashboard/Classes.vue";
import StudentAssessments from "@/views/Student/Dashboard/Assessments.vue";
import QuizTest from "@/views/Student/Dashboard/QuizTest.vue";
import StudentReport from "@/views/Student/Dashboard/Report.vue";
import InstructorCoursePreview from "@/views/Instructor/CoursePreview.vue";
import StudentGrade from "@/views/Student/GradeBook.vue";
import EditorJS from "@/views/EditorJS.vue";
import CompleteCourse from "@/views/Student/CompleteCourse.vue";
import CertificatePage from "@/views/Student/CertificatePage.vue";
import InstructorBlogs from "@/views/Instructor/Dashboard/Blogs.vue";
import CourseComplete from "@/views/Instructor/Dashboard/CourseComplete.vue";
import StudentProject from "@/views/Student/Dashboard/Project.vue";
import InstructorCertificatePage from "@/views/Instructor/CertificatePage.vue";
import InstructorBlogsView from "@/views/Instructor/InstructorBlogs.vue";
import InstructorBlogsList from "@/views/Instructor/InstructorBlogsList.vue";
import InstructorBlogDetails from "@/views/Instructor/InstructorBlogDetails.vue";
import InstructorBlogsEdit from "@/views/Instructor/EditBlogs.vue";
import StudentNotifications from "@/views/Student/Notifications.vue";
// import InstructorNotifcations from "@/views/Instructor/Notifications.vue";
import StudentBlogs from "@/views/Student/BlogsView.vue";
import StudentBlogsList from "@/views/Student/BlogsList.vue";
import PageNotFound from "@/views/PageNotFound.vue";
import SkillGapAnalysis from "@/views/Instructor/Dashboard/SkillGapAnalysis.vue";
import InstructorInviteCourse from "@/views/Instructor/Dashboard/InviteCourse.vue";
import AdminHome from "@/views/Admin/AdminHome.vue";
import AdminDashboard from "@/views/Admin/Dashboard.vue";
import AdminStudents from "@/views/Admin/Dashboard/Students.vue";
import AdminProject from "@/views/Admin/Dashboard/Project.vue";
import AdminEvents from "@/views/Admin/Dashboard/Events.vue";
import AdminCourses from "@/views/Admin/Dashboard/Courses.vue";
import AdminInviteCourse from "@/views/Instructor/Dashboard/InviteCourse.vue";
import StudentTaskList from "@/views/Student/TaskList.vue";
import AdminAdmins from "@/views/Admin/Dashboard/Admins.vue";
// import AdminDashboards from "@/views/Admin/Dashboard/Dashboards.vue";
import AdminDashboards from "@/views/Admin/Dashboard/NewDashboard.vue";

import AttendanceView from "@/views/Attendance/AttendanceView.vue";
import AttendanceStudentList from "@/views/Attendance/AttendanceStudentList.vue";
import AttendanceListView from "@/views/Attendance/AttendanceListView.vue";
import AttendanceCalender from "@/views/Attendance/AttendanceCalender.vue";

import InstructorNewForums from "@/views/Instructor/Dashboard/NewForums.vue";
import StudentNewForums from "@/views/Student/Dashboard/NewForums.vue";

import StudentAttendanceList from "@/views/Student/Attendance/StudentAttendanceList.vue";
import StudentCalender from "@/views/Student/Attendance/StudentCalender.vue";
import StudentTimeTable from "@/views/Student/Attendance/StudentTimeTable.vue";
import StudentFeedBack from "@/views/Student/Attendance/StudentFeedBack.vue";
import HodHome from "@/views/Hod/HodHome.vue";
import MentorHome from "@/views/Mentor/MentorHome.vue";
import CoordinateHome from "@/views/Coordinate/CoordinateHome.vue";

import HodAttendance from "@/views/Hod/Attendance.vue";
import AdminAttendance from "@/views/Admin/Attendance.vue";
import CoordinateAttendance from "@/views/Coordinate/Attendance.vue";
import InstructorAttendance from "@/views/Instructor/Attendance.vue";
import MentorAttendance from "@/views/Mentor/Attendance.vue";

// admin details
import AdminUpload from "@/views/Admin/AdminUpload.vue";
import AdminStudentDetail from "@/views/Admin/Details/StudentDetails.vue";
import AdminStaffDetails from "@/views/Admin/Details/StaffDetails.vue";
import AdminDepartmentDetails from "@/views/Admin/Details/DepartmentDetails.vue";
import AdminSemesterDetails from "@/views/Admin/Details/SemesterDetails.vue";
import AdminBatchDetails from "@/views/Admin/Details/BatchDetails.vue";
import AdminProgramsDetails from "@/views/Admin/Details/ProgramsDetails.vue";
import DepartmentInnerPage from "@/views/Admin/Details/DepartmentInnerPage.vue";
import ProgramInnerPage from "@/views/Admin/Details/ProgramInnerPage.vue";

import InstructorStudentAssign from "@/views/Instructor/StudentAssign.vue";
import AdminNewCourses from "@/views/Admin/NewCourse.vue";
import AdminCoursess from "@/views/Admin/AdminCourses.vue";
import AdminStudentAssign from "@/views/Admin/StudentAssign.vue";

import instructorCounts from "@/views/Instructor/CountView.vue";
import instructorCoursesNew from "@/views/Instructor/CourseView.vue";
import HodCounts from "@/views/Hod/CountView.vue";
import HodBatches from "@/views/Hod/Batches.vue";
import HodCourses from "@/views/Hod/Courses.vue";
import HodCoursePreview from "@/views/Hod/CoursePreview.vue";
import HodSemesters from "@/views/Hod/Semesters.vue";
import coordinateCounts from "@/views/Coordinate/CountView.vue";
import coordinateCourses from "@/views/Coordinate/CourseView.vue";
import AttendanceTimeTable from "@/views/Instructor/AttendanceTimeTable.vue";
import MyTask from "@/views/Instructor/MyTask.vue";
import SyallbusView from "@/views/Instructor/SyallbusView.vue";
import SupportView from "@/views/Instructor/SupportView.vue";
import StudentSupportSystem from "@/views/Student/SupportSystem.vue";
import CoordinateProfile from "@/views/Coordinate/Profile.vue";
import CoordinateTimeTable from "@/views/Coordinate/AttendanceTimeTable.vue";
import CoordinateMyTask from "@/views/Coordinate/MyTask.vue";
import CoordinateSyallbusView from "@/views/Coordinate/SyallbusView.vue";
import CoordinateSupportView from "@/views/Coordinate/SupportView.vue";

import AdminProfile from "@/views/Admin/Profile.vue";
import AdminTimeTable from "@/views/Admin/AttendanceTimeTable.vue";
import AdminMyTask from "@/views/Admin/MyTask.vue";
import AdminSyallbusView from "@/views/Admin/SyallbusView.vue";

import HodProfile from "@/views/Hod/Profile.vue";
import HodTimeTable from "@/views/Hod/AttendanceTimeTable.vue";
import HodMyTask from "@/views/Hod/MyTask.vue";
import HodSyallbusView from "@/views/Hod/SyallbusView.vue";

import HodDashboard from "@/views/Hod/Dashboard.vue";
import HodCoursess from "@/views/Hod/Dashboard/Courses.vue";
import HodProject from "@/views/Hod/Dashboard/Project.vue";
import HodEvents from "@/views/Hod/Dashboard/Events.vue";
import HodDashboards from "@/views/Hod/Dashboard/NewDashboard.vue";

// admin files
import StroageFiles from "@/views/Admin/Files/StroageFiles.vue";

import ChildPage from "@/views/Admin/Files/ChildPage.vue";
import FileChildPage from "@/views/Admin/Files/FileChildPage.vue";
// Hod details
import HodStudentDetail from "@/views/Hod/Details/StudentDetails.vue";
import HodStaffDetails from "@/views/Hod/Details/StaffDetails.vue";
import HodDepartmentDetails from "@/views/Hod/Details/DepartmentDetails.vue";
import HodSemesterDetails from "@/views/Hod/Details/SemesterDetails.vue";
import HodBatchDetails from "@/views/Hod/Details/BatchDetails.vue";
import HodProgramsDetails from "@/views/Hod/Details/ProgramsDetails.vue";
import DepartmentInnerDetails from "@/views/Hod/Details/DepartmentInnerPage.vue";
import ProgramInnerDetails from "@/views/Hod/Details/ProgramInnerPage.vue";

import StudentSyallbusView from "@/views/Student/SyallbusView.vue";
import HomeHelp from "@/components/HomeHelp.vue";
import AdminCoursePreview from "@/views/Admin/AdminCoursePreview.vue";

import AddStudents from "@/views/Instructor/Dashboard/AddStudent.vue";
import InstructorAllStudents from "@/views/Instructor/Dashboard/AllStudentView.vue";

import StudentMessagesList from "@/views/Student/MessageList.vue";
import LessonView from "@/views/Student/Dashboard/Lesson.vue";
import AssignmentDetail from "@/views/Student/Dashboard/AssignmentDetail.vue";
import InstructorMessageUser from "@/views/Instructor/Dashboard/ChatUserById.vue";
import codingView from "@/views/Student/codingView.vue";
import CoordinateUpload from "@/views/Coordinate/CoordinateUpload.vue";
import {
  loginGuards,
  adminGuards,
  studentGuards,
  instructorGuards,
  hodGuards,
  mentorGuards,
  coOrdianateGuards,
  studentCourseGuards,
  adminhodcodGuards,
} from "./guards";

import InstructorProfile from "@/views/Instructor/Profile.vue";
import QuizVaildate from "@/views/Instructor/Dashboard/QuizVaildate.vue";
import COPOPSO from "@/views/Instructor/Dashboard/COPOPSO.vue";

import AddLessonUnit from "@/views/Common/AddUnitAndLesson.vue";
import AddLessonUnitForBatch from "@/views/Common/AddLessonUnitForBatch.vue";
import EditCourseForBatch from "@/views/Common/EditCourseForBatch.vue";
import InstructorNewMessages from "@/views/Instructor/Dashboard/NewMessages.vue";
import StudentNewMessages from "@/views/Student/Dashboard/NewMessages.vue";
import GradeBook from "@/views/Instructor/Dashboard/GradeBook.vue";
import AssignmentGrade from "@/views/Instructor/GradeDetail/AssignmentGrade.vue";
import AssessmentMark from "@/views/Instructor/GradeDetail/AssessmentMark.vue";

import BulkUpload from "@/views/Common/BulkUpload.vue";
import AICourseCreate from "@/views/Admin/AICourseCreate.vue";
import PollStudents from "@/views/Instructor/Dashboard/PollStudents.vue";
import CourseDetailsUpdate from "@/views/Admin/CourseDetailsUpdate.vue";

import HomeWorks from "@/views/Instructor/Dashboard/Homeworks.vue";
import StudentHomeWorks from "@/views/Student/Dashboard/Homeworks.vue";
import StudentHomeworkDetail from "@/views/Student/Dashboard/HomeWorkDetailPage.vue";
import AdminHomeworkDetail from "@/views/Instructor/Dashboard/HomeworkDetail.vue";

import SingleFeedback from "@/views/Instructor/Dashboard/AssignmentFeedback/SingleFeedback.vue";
import OverallFeedback from "@/views/Instructor/Dashboard/AssignmentFeedback/OverallFeedback.vue";
import HomeworkSingleFeedback from "@/views/Instructor/Dashboard/HomeworkFeedback/SingleFeedback.vue";
import HomeworkOverallFeedback from "@/views/Instructor/Dashboard/HomeworkFeedback/OverallFeedback.vue";

import AiCourseCreatePrompt from "@/views/Admin/AiCourseCreatePrompt.vue";
import PromptList from "@/views/Admin/PromptsList.vue";
import GeminiPreview from "@/views/Admin/GeminiPreview.vue";

import DownloadHistory from "@/views/DownloadHistory.vue";
import AssessmentSingleFeedback from "@/views/Instructor/Dashboard/AssessmentFeedback/SingleFeedback.vue";
import AssessmentOverallFeedback from "@/views/Instructor/Dashboard/AssessmentFeedback/OverallFeedback.vue";

import SSOLogin from "@/views/SSOLogin.vue";
import ChangePassword from "@/views/ChangePassword.vue";
import TriggerView from "@/views/Admin/TriggerView.vue";
import StudentList from "@/views/Admin/Details/StudentList.vue";
import StaffList from "@/views/Admin/Details/StaffList.vue";
import StudentCourseList from "@/views/Admin/Details/StudentCourseList.vue";
import FeedbackView from "@/views/Admin/FeedbackView.vue";
import LiveclassAttendance from "@/views/Instructor/Dashboard/LiveclassAttendance.vue";
import InternalMark from "@/views/Instructor/Dashboard/InternalMark.vue";
import EmailTemplate from "@/views/Admin/EmailTemplate.vue";

import StroageFilesView from "@/views/Files/StroageFiles.vue";
import ChildPageView from "@/views/Files/ChildPage.vue";
import EmailLogs from "@/views/Admin/EmailLogs.vue";
import EmailTable from "@/views/Admin/EmailTable.vue";
import HtmlpageRender from "@/views/Instructor/Dashboard/HtmlpageRender.vue";
import StudentNotificationList from "@/views/Admin/Details/StudentNotificationList.vue";
import StudentEmailList from "@/views/Admin/Details/StudentEmailList.vue";
import HtmlStudentpageRender from "@/views/Student/Dashboard/HtmlpageRender.vue";
import EmailEditTemplate from "@/views/Admin/EmailEditTemplate.vue";
import OverAllDownload from "@/views/Admin/OverAllDownload.vue";
import DownloadLogs from "@/views/Admin/DownloadLogs.vue";

// staff studentpreview
import PreviewStudentDashboard from "@/views/Student_preview/Dashboard.vue";
import PreviewStudentCourseProgress from "@/views/Student_preview/Dashboard/CourseProgress.vue";
import PreviewStudentCourse from "@/views/Student_preview/CoursePreview.vue";
import PreviewStudentNewMessages from "@/views/Student_preview/Dashboard/NewMessages.vue";
import PreviewStudentAssignments from "@/views/Student_preview/Dashboard/Assignments.vue";
import PreviewStudentNewForums from "@/views/Student_preview/Dashboard/NewForums.vue";
import PreviewStudentClasses from "@/views/Student_preview/Dashboard/Classes.vue";
import PreviewStudentAssessments from "@/views/Student_preview/Dashboard/Assessments.vue";
import PreviewStudentProject from "@/views/Student_preview/Dashboard/Project.vue";
import PreviewAssignmentDetail from "@/views/Student_preview/Dashboard/AssignmentDetail.vue";
import PreviewLessonView from "@/views/Student_preview/Dashboard/Lesson.vue";
import PreviewQuizTest from "@/views/Student_preview/Dashboard/QuizTest.vue";
import PreviewStudentHome from "@/views/Student_preview/StudentHome.vue";
import PreviewMyCourse from "@/views/Student_preview/MyCourse.vue";
import PreviewStudentBlogs from "@/views/Student_preview/BlogsView.vue";
import PreviewStudentBlogsList from "@/views/Student_preview/BlogsList.vue";
import PreviewCompleteCourse from "@/views/Student_preview/CompleteCourse.vue";
import PreviewCertificatePage from "@/views/Student_preview/CertificatePage.vue";
import PreviewStudentNotifications from "@/views/Student_preview/Notifications.vue";
import PreviewStudentTaskList from "@/views/Student_preview/TaskList.vue";
import PreviewStudentSyallbusView from "@/views/Student_preview/SyallbusView.vue";
import PreviewStudentUserProfile from "@/views/Student_preview/UserProfile.vue";
import PreviewStudentMessageList from "@/views/Student_preview/MessageList.vue";
import TicketList from "@/views/Tickets/TicketList.vue";
import TicketDetail from "@/views/Tickets/TicketDetail.vue";
import GradBook from "@/views/Student/Dashboard/GradBook.vue";
import UserView from "@/views/Admin/UserView.vue";
import UserCourse from "@/views/Admin/UserCourse.vue";
import QuizsScoreboard from "@/views/Instructor/Dashboard/QuizsScoreboard.vue";
import RewardsView from "@/views/Student/RewardsView.vue";
import SurveyList from "@/views/Admin/SurveyList.vue";
import SurveyCreate from "@/views/Admin/SurveyCreate.vue";
import SurveyEdit from "@/views/Admin/SurveyEdit.vue";
import SurveyResponses from "@/views/Admin/SurveyResponses.vue";

const routes = [
  {
    path: "/rewards",
    name: "RewardsView",
    component: RewardsView,
    props: true,
  },
  {
    path: "/mycourse/:studentid/:studentsem/:studentdep/:tokens",
    name: "UserCourse",
    component: UserCourse,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/userview/:student_id/:student_sem/:student_dep/:token",
    name: "UserView",
    component: UserView,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/ticket",
    name: "TicketList",
    component: TicketList,
    beforeEnter: adminGuards,
  },
  {
    path: "/ticket/detail/:id",
    name: "TicketDetail",
    component: TicketDetail,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/download-logs",
    name: "DownloadLogs",
    component: DownloadLogs,
    beforeEnter: adminGuards,
  },
  {
    path: "/download",
    name: "OverAllDownload",
    component: OverAllDownload,
    beforeEnter: adminGuards,
  },
  {
    path: "/student-notification/:id/:email",
    name: "StudentNotificationList",
    component: StudentNotificationList,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/student-email/:id/:email",
    name: "StudentEmailList",
    component: StudentEmailList,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/email-table/:id/:emailtitle",
    name: "EmailTable",
    component: EmailTable,
    beforeEnter: adminGuards,
  },
  {
    path: "/email-logs",
    name: "EmailLogs",
    component: EmailLogs,
    beforeEnter: adminGuards,
  },
  {
    path: "/files/:token/:id",
    name: "FileChildPage",
    component: FileChildPage,
  },
  {
    path: "/email/template",
    name: "EmailTemplate",
    component: EmailTemplate,
    beforeEnter: adminGuards,
  },
  {
    path: "/email-template/edit/:slug/:templateSlug?",
    name: "EmailEditTemplate",
    component: EmailEditTemplate,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/ChildPageView/child/:id",
    name: "ChildPageView",
    component: ChildPageView,
  },

  {
    path: "/StroageFilesView/uploaded-files",
    name: "StroageFilesView",
    component: StroageFilesView,
  },

  {
    path: "/child/:id",
    name: "ChildPage",
    component: ChildPage,
  },

  {
    path: "/uploaded-files",
    name: "StroageFiles",
    component: StroageFiles,
  },
  {
    path: "/feedback",
    name: "FeedbackView",
    component: FeedbackView,
    beforeEnter: adminGuards,
  },
  {
    path: "/surveys",
    name: "SurveyList",
    component: SurveyList,
    beforeEnter: adminGuards,
  },
  {
    path: "/surveys/responses/:id",
    name: "SurveyResponses",
    component: SurveyResponses,
    beforeEnter: adminGuards,
  },
  {
    path: "/surveys/create",
    name: "SurveyCreate",
    component: SurveyCreate,
    beforeEnter: adminGuards,
  },
  {
    path: "/surveys/edit/:id",
    name: "SurveyEdit",
    component: SurveyEdit,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/student/course/:student_id/:student_sem/:student_dep/:email/:token",
    name: "StudentCourseList",
    component: StudentCourseList,
    props: true,
    beforeEnter: adminGuards,
  },
  {
    path: "/student-list",
    name: "StudentList",
    component: StudentList,
    beforeEnter: adminGuards,
  },
  {
    path: "/staff-list",
    name: "StaffList",
    component: StaffList,
    beforeEnter: adminGuards,
  },
  {
    path: "/trigger",
    name: "TriggerView",
    component: TriggerView,
    beforeEnter: adminGuards,
  },
  {
    path: "/single-uploads",
    name: "CoordinateUpload",
    component: CoordinateUpload,
  },
  {
    path: "/single-upload",
    name: "AdminUpload",
    component: AdminUpload,
    beforeEnter: adminGuards,
  },
  {
    path: "/coding-view/:course_id",
    name: "codingView",
    component: codingView,
  },
  {
    path: "/sso-login",
    name: "SSOLogin",
    component: SSOLogin,
  },
  {
    path: "/password/reset/:token",
    name: "ChangePassword",
    component: ChangePassword,
  },
  {
    path: "/download-history",
    name: "DownloadHistory",
    component: DownloadHistory,
    beforeEnter: adminhodcodGuards,
  },
  {
    path: "/gemini-preview/:course_id",
    name: "GeminiPreview",
    component: GeminiPreview,
    props: true,
    // GeminiPreview
  },
  {
    path: "/prompts",
    name: "PromptList",
    component: PromptList,
  },
  {
    path: "/ai-prompt",
    name: "AiCourseCreatePrompt",
    component: AiCourseCreatePrompt,
  },
  // AdminNewCourses
  // AddLessonUnitForBatch
  {
    path: "/course-details",
    name: "CourseDetailsUpdate",
    component: CourseDetailsUpdate,
  },
  {
    path: "/course-with-ai",
    name: "AICourseCreate",
    component: AICourseCreate,
    beforeEnter: adminGuards,
  },
  {
    path: "/bulk-create",
    name: "BulkUploadCreate",
    component: BulkUpload,
    beforeEnter: adminGuards,
  },
  {
    path: "/batches/course/edit/:course_id/:batch/:semester",
    name: "EditCourseForBatch",
    component: EditCourseForBatch,
    props: true,
  },
  {
    path: "/batches/add-unit-lesson/:course_id/:batch/:semester",
    name: "AddLessonUnitForBatch",
    component: AddLessonUnitForBatch,
    props: true,
  },
  {
    path: "/add-unit-lesson/:course_id",
    name: "AddLessonUnit",
    component: AddLessonUnit,
    props: true,
  },
  {
    path: "/course/preview/:course_id",
    name: "AdminCoursePreview",
    component: AdminCoursePreview,
    props: true,
  },
  {
    path: "/all/courses",
    name: "AdminCoursess",
    component: AdminCoursess,
    beforeEnter: adminhodcodGuards,
  },
  {
    path: "/add/new-courses",
    name: "AdminNewCourses",
    component: AdminNewCourses,
  },
  {
    path: "/students/assign/",
    name: "AdminStudentAssign",
    component: AdminStudentAssign,
    props: true,
  },
  {
    path: "/instructor/students/assign/",
    name: "InstructorStudentAssign",
    component: InstructorStudentAssign,
    props: true,
    beforeEnter: instructorGuards,
  },
  {
    path: "/mentor/attendance",
    name: "MentorAttendance",
    component: MentorAttendance,
    beforeEnter: mentorGuards,
  },
  {
    path: "/coordinate/profile",
    name: "CoordinateProfile",
    beforeEnter: coOrdianateGuards,
    component: CoordinateProfile,
  },
  {
    path: "/instructor/attendance",
    name: "InstructorAttendance",
    component: InstructorAttendance,
    beforeEnter: instructorGuards,
  },
  {
    path: "/coordinate/attendance",
    name: "CoordinateAttendance",
    component: CoordinateAttendance,
    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/admin/attendance",
    name: "AdminAttendance",
    component: AdminAttendance,
    // beforeEnter: adminGuards,
  },
  {
    path: "/hod/attendance",
    name: "HodAttendance",
    component: HodAttendance,
    // beforeEnter: hodGuards,
  },
  {
    path: "/mentor/home",
    name: "MentorHome",
    component: MentorHome,
    // beforeEnter: mentorGuards,
  },
  {
    path: "/hod/home",
    name: "HodHome",
    component: HodHome,
    beforeEnter: hodGuards,
  },
  {
    path: "/hod/profile",
    name: "HodProfile",
    component: HodProfile,

    beforeEnter: hodGuards,
  },
  {
    path: "/timetable",
    name: "HodTimeTable",
    component: HodTimeTable,

    beforeEnter: hodGuards,
  },
  {
    path: "/hod/task",
    name: "HodMyTask",
    component: HodMyTask,

    beforeEnter: hodGuards,
  },
  {
    path: "/hod/syallbus",
    name: "HodSyallbusView",
    component: HodSyallbusView,

    beforeEnter: hodGuards,
  },
  {
    path: "/coordinater/home",
    name: "CoordinateHome",
    component: CoordinateHome,
    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/admin/home",
    name: "AdminHome",
    component: AdminHome,
    beforeEnter: adminGuards,
  },
  {
    path: "/profile",
    name: "AdminProfile",
    component: AdminProfile,

    beforeEnter: adminGuards,
  },
  {
    path: "/timetable",
    name: "AdminTimeTable",
    component: AdminTimeTable,

    beforeEnter: adminGuards,
  },
  {
    path: "/admin/task",
    name: "AdminMyTask",
    component: AdminMyTask,

    beforeEnter: adminGuards,
  },
  {
    path: "/admin/syallbus",
    name: "AdminSyallbusView",
    component: AdminSyallbusView,
    beforeEnter: adminGuards,
  },
  {
    path: "/admin/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
    beforeEnter: adminGuards,
    props: (router) => ({ course_id: router.params.course_id }),
    children: [
      {
        path: "courses",
        name: "AdminCourses",
        component: AdminCourses,
        props: true,
      },
      {
        path: "students",
        name: "AdminStudents",
        component: AdminStudents,
        props: true,
      },
      {
        path: "project",
        name: "AdminProject",
        component: AdminProject,
        props: true,
      },
      {
        path: "events",
        name: "AdminEvents",
        component: AdminEvents,
        props: true,
      },
      {
        path: "invitecourse",
        name: "AdminInviteCourse",
        component: AdminInviteCourse,
        props: true,
      },
      {
        path: "admins",
        name: "AdminAdmins",
        component: AdminAdmins,
        props: true,
      },
      {
        path: "dashboards",
        name: "AdminDashboards",
        component: AdminDashboards,
      },
      {
        path: "student-detail",
        name: "AdminStudentDetail",
        component: AdminStudentDetail,
      },
      {
        path: "staff-detail",
        name: "AdminStaffDetails",
        component: AdminStaffDetails,
      },
      {
        path: "department-detail",
        name: "AdminDepartmentDetails",
        component: AdminDepartmentDetails,
      },
      {
        path: "semester-detail",
        name: "AdminSemesterDetails",
        component: AdminSemesterDetails,
      },
      {
        path: "batch-detail",
        name: "AdminBatchDetails",
        component: AdminBatchDetails,
      },
      {
        path: "program-detail",
        name: "AdminProgramsDetails",
        component: AdminProgramsDetails,
      },
      {
        path: "/department/list/:depart_id/:d_name",
        name: "DepartmentInnerPage",
        component: DepartmentInnerPage,
        props: (router) => ({
          depart_id: router.params.depart_id,
          d_name: router.params.d_name,
        }),
      },
      {
        path: "/program/list/:program_id/:p_name",
        name: "ProgramInnerPage",
        component: ProgramInnerPage,
        props: (router) => ({
          program_id: router.params.program_id,
          p_name: router.params.p_name,
        }),
      },
    ],
  },
  {
    path: "/:pagenotfound(.*)*",
    name: "PageNotFound",
    component: PageNotFound,
  },

  // Hod parent to child
  {
    path: "/hod/dashboard",
    name: "HodDashboard",
    component: HodDashboard,
    beforeEnter: hodGuards,
    props: (router) => ({ course_id: router.params.course_id }),
    children: [
      {
        path: "courses",
        name: "HodCoursess",
        component: HodCoursess,
        props: true,
      },

      {
        path: "project",
        name: "HodProject",
        component: HodProject,
        props: true,
      },
      {
        path: "events",
        name: "HodEvents",
        component: HodEvents,
        props: true,
      },

      {
        path: "dashboards",
        name: "HodDashboards",
        component: HodDashboards,
      },
      {
        path: "student-detail",
        name: "HodStudentDetail",
        component: HodStudentDetail,
      },
      {
        path: "staff-detail",
        name: "HodStaffDetails",
        component: HodStaffDetails,
      },
      {
        path: "department-detail",
        name: "HodDepartmentDetails",
        component: HodDepartmentDetails,
      },
      {
        path: "semester-detail",
        name: "HodSemesterDetails",
        component: HodSemesterDetails,
      },
      {
        path: "batch-detail",
        name: "HodBatchDetails",
        component: HodBatchDetails,
      },
      {
        path: "program-detail",
        name: "HodProgramsDetails",
        component: HodProgramsDetails,
      },
      {
        path: "/department/list/:depart_id/:d_name",
        name: "DepartmentInnerDetails",
        component: DepartmentInnerDetails,
        props: (router) => ({
          depart_id: router.params.depart_id,
          d_name: router.params.d_name,
        }),
      },
      {
        path: "/program/list/:program_id/:p_name",
        name: "ProgramInnerDetails",
        component: ProgramInnerDetails,
        props: (router) => ({
          program_id: router.params.program_id,
          p_name: router.params.p_name,
        }),
      },
    ],
  },
  {
    path: "/student/dashboard/:course_id",
    name: "StudentDashboard",
    component: StudentDashboard,
    beforeEnter: studentCourseGuards,
    props: (router) => ({ course_id: router.params.course_id }),
    children: [
      {
        path: "homeworks",
        name: "StudentHomeWorks",
        component: StudentHomeWorks,
        props: true,
      },
      {
        path: "lesson/:lesson_id/:title",
        name: "LessonView",
        component: LessonView,
        props: true,
      },
      {
        path: "video/:lesson_id",
        name: "StudentVideoPreview",
        component: StudentVideoPreview,
        props: true,
      },
      {
        path: "courses",
        name: "StudentCourseProgress",
        component: StudentCourseProgress,
        props: true,
      },
      {
        path: "messages",
        name: "StudentMessages",
        component: StudentMessages,
        props: true,
      },
      {
        path: "newmessages",
        name: "StudentNewMessages",
        component: StudentNewMessages,
        props: true,
      },
      {
        path: "assignments",
        name: "StudentAssignments",
        component: StudentAssignments,
        props: true,
      },
      {
        path: "forums",
        name: "StudentForums",
        component: StudentForums,
        props: true,
      },
      {
        path: "newforums",
        name: "StudentNewForums",
        component: StudentNewForums,
        props: true,
      },
      {
        path: "classes",
        name: "StudentClasses",
        component: StudentClasses,
        props: true,
      },
      {
        path: "assessments",
        name: "StudentAssessments",
        component: StudentAssessments,
        props: true,
      },
      {
        path: "reports",
        name: "StudentReport",
        component: StudentReport,
        props: true,
      },
      {
        path: "projects",
        name: "StudentProject",
        component: StudentProject,
        props: true,
      },
      {
        path: "assignment-detail/:assignment_id",
        name: "AssignmentDetail",
        component: AssignmentDetail,
        props: true,
      },
      {
        path: "homework-detail/:assignment_id",
        name: "StudentHomeworkDetail",
        component: StudentHomeworkDetail,
        props: true,
      },
      {
        path: "html-render",
        name: "HtmlStudentpageRender",
        component: HtmlStudentpageRender,
        props: true,
      },
      {
        path: "gradbook",
        name: "GradBook",
        component: GradBook,
        props: true,
      },
    ],
  },
  {
    path: "/quiz/test/:course_id/:quiz_id",
    name: "QuizTest",
    component: QuizTest,
    props: true,
  },
  {
    path: "/student/grade/",
    name: "StudentGrade",
    component: StudentGrade,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/completecourse/",
    name: "CompleteCourse",
    component: CompleteCourse,
    beforeEnter: studentGuards,
  },
  {
    path: "/tasklist/",
    name: "StudentTaskList",
    component: StudentTaskList,
    beforeEnter: studentGuards,
  },
  {
    path: "/certificate/:complete_course_slug/:complete_profile_slug",
    name: "CertificatePage",
    component: CertificatePage,
    props: (router) => ({
      complete_course_slug: router.params.complete_course_slug,
      complete_profile_slug: router.params.complete_profile_slug,
    }),
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/course/:courseid",
    name: "StudentCourse",
    component: StudentCourse,
    props: (router) => ({
      courseid: router.params.courseid,
    }),
    props: true,
    beforeEnter: studentGuards,
  },
  // {
  //   path: "/student/videorender",
  //   name: "StudentVideoRender",
  //   component: StudentVideoRender,
  // },
  {
    path: "/student/curriculum",
    name: "StudentCurriculum",
    component: StudentCurriculum,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/community",
    name: "StudentCommunity",
    component: StudentCommunity,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/mycourse",
    name: "StudentMyCourse",
    component: StudentMyCourse,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/blogs",
    name: "StudentBlogs",
    component: StudentBlogs,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/blogs_list/:student_blog_id",
    name: "StudentBlogsList",
    component: StudentBlogsList,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/signup",
    name: "SignUp",
    component: SignUp,
    meta: { guest: true },
    beforeEnter: loginGuards,
  },
  {
    path: "/student/userprofile",
    name: "StudentUserProfile",
    component: StudentUserProfile,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/passwordchange",
    name: "StudentPasswordChange",
    component: StudentPasswordChange,
    beforeEnter: studentGuards,
    // props: (router) => ({
    //   keyword: router.params.keyword,
    //   keyval: router.params.keyval,
    // }),
  },
  {
    path: "/attendance-list",
    name: "StudentAttendanceList",
    component: StudentAttendanceList,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/calender",
    name: "StudentCalender",
    component: StudentCalender,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/timetable",
    name: "StudentTimeTable",
    component: StudentTimeTable,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/feedback",
    name: "StudentFeedBack",
    component: StudentFeedBack,
    props: true,
    beforeEnter: studentGuards,
  },
  {
    path: "/supportsystem",
    name: "StudentSupportSystem",
    component: StudentSupportSystem,
    beforeEnter: studentGuards,
  },
  // Instructor Start
  {
    path: "/course/dashboard/:course_id/:department_id",
    name: "InstructorDashboard",
    component: InstructorDashboard,
    beforeEnter: adminhodcodGuards,
    props: (router) => ({
      course_id: router.params.course_id,
      department_id: router.params.department_id,
    }),
    children: [
      {
        // HomeWorks
        path: "home-works",
        name: "HomeWorks",
        component: HomeWorks,
        props: true,
      },
      {
        path: "lesson-poll",
        name: "PollStudents",
        component: PollStudents,
        props: true,
      },
      {
        path: "add-student",
        name: "AddStudents",
        component: AddStudents,
        props: true,
      },
      {
        path: "skill-analysis",
        name: "SkillGapAnalysis",
        component: SkillGapAnalysis,
        props: true,
      },
      {
        path: "messages",
        name: "InstructorMessages",
        component: InstructorMessages,
        props: true,
      },
      {
        path: "messagesbyid/:uuid",
        name: "InstructorMessageUser",
        component: InstructorMessageUser,
        props: true,
      },
      {
        path: "newmessages",
        name: "InstructorNewMessages",
        component: InstructorNewMessages,
        props: true,
      },
      {
        path: "students",
        name: "InstructorStudents",
        component: InstructorStudents,
        props: true,
      },
      {
        path: "assignments",
        name: "InstructorAssignments",
        component: InstructorAssignments,
        props: true,
      },
      {
        path: "assignments/submitted/:assignment_id",
        name: "InstructorAssignmentsSubmitted",
        component: InstructorAssignmentsSubmitted,
        props: true,
      },
      {
        path: "assignments/feedback/:assignment_id",
        name: "SingleFeedback",
        component: SingleFeedback,
        props: true,
      },
      {
        path: "assignments/feedback",
        name: "OverallFeedback",
        component: OverallFeedback,
        props: true,
      },
      {
        path: "homework/submitted/:assignment_id",
        name: "AdminHomeworkDetail",
        component: AdminHomeworkDetail,
        props: true,
      },
      {
        path: "homework/feedback/:assignment_id",
        name: "HomeworkSingleFeedback",
        component: HomeworkSingleFeedback,
        props: true,
      },
      {
        path: "homework/feedback/",
        name: "HomeworkOverallFeedback",
        component: HomeworkOverallFeedback,
        props: true,
      },
      {
        path: "forums",
        name: "InstructorForums",
        component: InstructorForums,
        props: true,
      },
      {
        path: "newforums",
        name: "InstructorNewForums",
        component: InstructorNewForums,
        props: true,
      },
      {
        path: "quizs",
        name: "InstructorQuizs",
        component: InstructorQuizs,
        props: true,
      },
      {
        path: "Scoreboard/:quiz_id/:quiz_name",
        name: "QuizsScoreboard",
        component: QuizsScoreboard,
        props: true,
      },
      {
        path: "assessment/feedback/",
        name: "AssessmentOverallFeedback",
        component: AssessmentOverallFeedback,
        props: true,
      },
      {
        path: "assessment/feedback/:quiz_id",
        name: "AssessmentSingleFeedback",
        component: AssessmentSingleFeedback,
        props: true,
      },
      {
        path: "classes",
        name: "InstructorClasses",
        component: InstructorClasses,
        props: true,
      },
      {
        path: "blogs",
        name: "InstructorBlogs",
        component: InstructorBlogs,
        props: true,
      },
      {
        path: "coursecomplete",
        name: "CourseComplete",
        component: CourseComplete,
        props: true,
      },
      {
        path: "invitecourse",
        name: "InstructorInviteCourse",
        component: InstructorInviteCourse,
        props: true,
      },
      {
        path: "copopso",
        name: "COPOPSO",
        component: COPOPSO,
        props: true,
      },
      {
        path: "allstudents",
        name: "InstructorAllStudents",
        component: InstructorAllStudents,
        props: true,
      },
      {
        path: "gradebook",
        name: "GradeBook",
        component: GradeBook,
        props: true,
      },
      {
        path: "gradebook/assessment/:assessment_id/:assessment_title",
        name: "AssessmentMark",
        component: AssessmentMark,
        props: true,
      },
      {
        path: "gradebook/assignment/:assignment_id/:assignment_title",
        name: "AssignmentGrade",
        component: AssignmentGrade,
        props: true,
      },
      {
        path: "liveclass/attendance",
        name: "LiveclassAttendance",
        component: LiveclassAttendance,
        props: true,
      },
      {
        path: "internal-mark",
        name: "InternalMark",
        component: InternalMark,
        props: true,
      },
      {
        path: "html-render",
        name: "HtmlpageRender",
        component: HtmlpageRender,
        props: true,
      },
    ],
  },
  // attendance routes
  {
    path: "/overall-attendance",
    name: "AttendanceCalender",
    component: AttendanceCalender,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/attendance",
    name: "AttendanceView",
    component: AttendanceView,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/attendance-list/:subject_pk/:faculty_time_table_pk/:session/",
    name: "AttendanceListView",
    component: AttendanceListView,
    // props: true,
    props: (router) => ({
      subject_pk: router.params.subject_pk,
      faculty_time_table_pk: router.params.faculty_time_table_pk,
      session: router.params.session,
    }),
    // beforeEnter: instructorGuards,
  },
  {
    path: "/studentlist/:subject_pk/:timetable_pk/:title/:section",
    name: "AttendanceStudentList",
    component: AttendanceStudentList,
    // props: true,
    props: (router) => ({
      subject_pk: router.params.subject_pk,
      timetable_pk: router.params.timetable_pk,
      title: router.params.title,
      section: router.params.section,
    }),
    // beforeEnter: instructorGuards,
  },
  // {
  //   path: '/instructor/messages',
  //   name: 'InstructorMessages',
  //   component: InstructorMessages
  // },
  // {
  //   path: '/instructor/dashboard',
  //   name: 'InstructorStudents',
  //   component: InstructorStudents
  // },
  {
    path: "/instructor/Help",
    name: "HomeHelpIn",
    beforeEnter: instructorGuards,
    component: HomeHelpIn,
  },
  {
    path: "/instructor/editorjs",
    name: "editorjs",
    beforeEnter: instructorGuards,
    component: EditorTry,
  },
  // InstructorProfile
  {
    path: "/instructor/profile",
    name: "InstructorProfile",
    beforeEnter: instructorGuards,
    component: InstructorProfile,
  },
  {
    path: "/instructor/new-courses",
    name: "InstructorNewCourses",
    component: InstructorNewCourses,
  },
  {
    path: "/instructor/preivew/:courseid/",
    name: "InstructorCoursePreview",
    component: InstructorCoursePreview,
    props: true,
    beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/course/quiz-validate/:course_id/:quiz_id/:taker_id",
    name: "QuizVaildate",
    component: QuizVaildate,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/course/:course_id/add",
    name: "InstructorCourseAdd",
    component: InstructorCourseAdd,
    props: true,
  },
  {
    path: "/course/:course_id/edit",
    name: "InstructorCourseEdit",
    component: InstructorCourseEdit,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/home",
    name: "InstructorHome",
    component: InstructorHome,
    beforeEnter: instructorGuards,
  },
  // {
  //   path: "/instructor/notifications",
  //   name: "InstructorNotifcations",
  //   component: InstructorNotifcations,
  //   // beforeEnter: instructorGuards,
  // },
  {
    path: "/instructor/courses",
    name: "InstructorCourses",
    component: InstructorCourses,
    beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/blogs",
    name: "InstructorBlogsView",
    component: InstructorBlogsView,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/blogs/list",
    name: "InstructorBlogsList",
    component: InstructorBlogsList,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/blogs/details/:blog_id",
    name: "InstructorBlogDetails",
    component: InstructorBlogDetails,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/certificate/preivew/:all_course_id/",
    name: "InstructorCertificatePage",
    component: InstructorCertificatePage,
    props: true,
    beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/blogs/:blog_id/edit",
    name: "InstructorBlogsEdit",
    component: InstructorBlogsEdit,
    props: true,
    // beforeEnter: instructorGuards,
  },
  {
    path: "/timetable",
    name: "AttendanceTimeTable",
    component: AttendanceTimeTable,

    beforeEnter: instructorGuards,
  },
  {
    path: "/task",
    name: "MyTask",
    component: MyTask,

    beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/syallbus",
    name: "SyallbusView",
    component: SyallbusView,

    beforeEnter: instructorGuards,
  },

  {
    path: "/support",
    name: "SupportView",
    component: SupportView,

    beforeEnter: instructorGuards,
  },
  // Instructor End

  {
    path: "/student/home",
    name: "StudentHome",
    component: StudentHome,
    props: (router) => ({ course_id: router.params.course_id }),
    beforeEnter: studentGuards,
  },
  {
    path: "/student/Community",
    name: "Community",
    component: StudentHome,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/Mycourse",
    name: "Mycourse",
    component: StudentHome,
    beforeEnter: studentGuards,
  },
  {
    path: "/student/StudentCourseCurriculum",
    name: "StudentCourseCurriculum",
    component: StudentHome,
    beforeEnter: studentGuards,
  },
  {
    path: "/",
    name: "Login",
    component: Login,
    beforeEnter: loginGuards,
  },
  {
    path: "/editorjs",
    name: "EditorJS",
    component: EditorJS,
  },
  {
    path: "/notifications",
    name: "StudentNotifications",
    component: StudentNotifications,
    // beforeEnter: studentGuards,
  },
  {
    path: "/messages",
    name: "StudentMessagesList",
    component: StudentMessagesList,
  },
  // new routes (config.js)
  {
    path: "/instructor/counts",
    name: "instructorCounts",
    component: instructorCounts,
    beforeEnter: instructorGuards,
  },
  {
    path: "/instructor/course",
    name: "instructorCoursesNew",
    component: instructorCoursesNew,
    beforeEnter: instructorGuards,
  },
  {
    path: "/hod/counts",
    name: "HodCounts",
    component: HodCounts,
    beforeEnter: hodGuards,
  },
  {
    path: "/batches",
    name: "HodBatches",
    component: HodBatches,
  },
  {
    path: "/semesters/:batch",
    name: "HodSemesters",
    component: HodSemesters,
    props: (router) => ({ batch: router.params.batch }),
  },
  {
    path: "/courses/:batch/:semester",
    name: "HodCourses",
    component: HodCourses,
    props: (router) => ({
      batch: router.params.batch,
      semester: router.params.semester,
    }),
  },
  {
    path: "/courses/preview/:course/:semester/:batch",
    name: "HodCoursePreview",
    component: HodCoursePreview,
    props: (router) => ({
      course: router.params.course,
      semester: router.params.semester,
    }),
  },
  {
    path: "/coordinate/counts",
    name: "coordinateCounts",
    component: coordinateCounts,
    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/coordinate/courses",
    name: "coordinateCourses",
    component: coordinateCourses,
    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/timetable",
    name: "CoordinateTimeTable",
    component: CoordinateTimeTable,

    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/coordinate/task",
    name: "CoordinateMyTask",
    component: CoordinateMyTask,

    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/coordinate/syallbus",
    name: "CoordinateSyallbusView",
    component: CoordinateSyallbusView,

    beforeEnter: coOrdianateGuards,
  },

  {
    path: "/support",
    name: "CoordinateSupportView",
    component: CoordinateSupportView,

    beforeEnter: coOrdianateGuards,
  },
  {
    path: "/student/syallbus",
    name: "StudentSyallbusView",
    component: StudentSyallbusView,

    beforeEnter: studentGuards,
  },
  {
    path: "/student/help",
    name: "HomeHelpvue",
    component: HomeHelp,
    beforeEnter: studentGuards,
  },
  // Staff student preview

  // {
  //   path: "/student/course/:courseid",
  //   name: "PreviewStudentCourse",
  //   component: PreviewStudentCourse,
  //   props: (router) => ({
  //     courseid: router.params.courseid,
  //   }),
  //   props: true,
  // },
  // {
  //   path: "/quiz/test/:course_id/:quiz_id",
  //   name: "PreviewQuizTest",
  //   component: PreviewQuizTest,
  //   props: true,
  // },
  // {
  //   path: "/student/home",
  //   name: "PreviewStudentHome",
  //   component: PreviewStudentHome,
  //   props: (router) => ({ course_id: router.params.course_id }),
  // },
  {
    path: "/student/dashboard/:course_id",
    name: "PreviewStudentDashboard",
    component: PreviewStudentDashboard,
    props: (route) => ({ course_id: route.params.course_id }),
    children: [
      {
        path: "quiz/test/:quiz_id/:feedback",
        name: "PreviewQuizTest",
        component: PreviewQuizTest,
        props: true,
      },
      {
        path: "student/userprofile",
        name: "PreviewStudentUserProfile",
        component: PreviewStudentUserProfile,
      },
      {
        path: "student/syallbus",
        name: "PreviewStudentSyallbusView",
        component: PreviewStudentSyallbusView,
      },
      {
        path: "tasklist/",
        name: "PreviewStudentTaskList",
        component: PreviewStudentTaskList,
      },
      {
        path: "student/message",
        name: "PreviewStudentMessageList",
        component: PreviewStudentMessageList,
      },
      {
        path: "student/notifications",
        name: "PreviewStudentNotifications",
        component: PreviewStudentNotifications,
      },
      {
        path: "certificate/:complete_course_slug/:complete_profile_slug",
        name: "PreviewCertificatePage",
        component: PreviewCertificatePage,
        props: (router) => ({
          complete_course_slug: router.params.complete_course_slug,
          complete_profile_slug: router.params.complete_profile_slug,
        }),
        props: true,
      },
      {
        path: "completecourse/",
        name: "PreviewCompleteCourse",
        component: PreviewCompleteCourse,
      },
      {
        path: "student/blogs",
        name: "PreviewStudentBlogs",
        component: PreviewStudentBlogs,
      },
      {
        path: "student/blogs_list/:student_blog_id",
        name: "PreviewStudentBlogsList",
        component: PreviewStudentBlogsList,
        props: true,
      },
      {
        path: "mycourse",
        name: "PreviewMyCourse",
        component: PreviewMyCourse,
        props: true,
      },
      {
        path: "student/home",
        name: "PreviewStudentHome",
        component: PreviewStudentHome,
        props: true,
      },
      {
        path: "preview/course",
        name: "PreviewStudentCourse",
        component: PreviewStudentCourse,
        props: true,
      },
      {
        path: "lesson/:lesson_id/:title",
        name: "PreviewLessonView",
        component: PreviewLessonView,
        props: true,
      },
      // {
      //   path: "video/:lesson_id",
      //   name: "StudentVideoPreview",
      //   component: StudentVideoPreview,
      //   props: true,
      // },
      {
        path: "courses",
        name: "PreviewStudentCourseProgress",
        component: PreviewStudentCourseProgress,
        props: true,
      },

      {
        path: "newmessages",
        name: "PreviewStudentNewMessages",
        component: PreviewStudentNewMessages,
        props: true,
      },
      {
        path: "assignments",
        name: "PreviewStudentAssignments",
        component: PreviewStudentAssignments,
        props: true,
      },

      {
        path: "newforums",
        name: "PreviewStudentNewForums",
        component: PreviewStudentNewForums,
        props: true,
      },
      {
        path: "classes",
        name: "PreviewStudentClasses",
        component: PreviewStudentClasses,
        props: true,
      },
      {
        path: "assessments",
        name: "PreviewStudentAssessments",
        component: PreviewStudentAssessments,
        props: true,
      },

      {
        path: "projects",
        name: "PreviewStudentProject",
        component: PreviewStudentProject,
        props: true,
      },
      {
        path: "assignment-detail/:assignment_id",
        name: "PreviewAssignmentDetail",
        component: PreviewAssignmentDetail,
        props: true,
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
  // scrollBehavior(to, from, savedPosition) {
  //   // Returning false disables scrolling
  //   return false;
  // }
});

export default router;
